{
  "layer_dwg": "camada como DWG",
  "layer_kml": "camada como KML",
  "drawing_units": "Unidades de desenho",
  "coordinate_system": "Sistema de coordenadas",
  "advanced_rebase_options": "Opções avançadas de rebase",
  "source_latitude": "Latitude da fonte",
  "source_longitude": "Longitude da fonte",
  "target_x": "Alvo X",
  "target_y": "Alvo Y",
  "target_rotation": "Rotação do alvo (graus)",
  "export_dwg": "Exportar DWG",
  "route_convert_line": "Converter em linha",
  "route_convert_confirmation": {
    "title": "Converter rota em linha",
    "message": "Tem certeza de que deseja converter essa rota em uma linha? Essa ação não pode ser desfeita."
  },
  "styles": {
    "lineTypes": {
      "dotted": "Pontilhado",
      "smallDash": "Pequeno tracejado",
      "largeDash": "Grande tracejado"
    }
  },
  "no_copy_empty_group": "Não é possível copiar: a seleção não contém camadas",
  "map_group_status": {
    "title": "Camadas/grupos de grupos de grupos",
    "explain": "Agrupe camadas e outros grupos",
    "nested_level": "Os grupos só podem ter 3 níveis de profundidade",
    "parent": "Os itens não podem estar em grupos diferentes",
    "amount": "Selecione pelo menos um item para ativar o agrupamento",
    "type": "A seleção não deve conter objetos de mapa",
    "loading": "Aguarde até que o mapa termine de carregar",
    "permissions": "É necessária a permissão de “Acesso total” no plano para ativar o agrupamento"
  },
  "map_unlink_status": {
    "title": "Desvincular camadas",
    "explain": "Separa e copia camadas do plano original",
    "amount": "Selecione pelo menos uma camada vinculada para ativar a desvinculação de camadas",
    "type": "A seleção deve conter somente camadas vinculadas",
    "loading": "Aguarde até que o mapa termine de carregar",
    "permissions": "É necessária a permissão 'Editar' no plano para desvincular camadas"
  },
  "copy_status": {
    "title": "Copiar camadas/grupos",
    "explain": "Faz uma cópia das camadas e grupos selecionados",
    "amount": "Selecione pelo menos uma camada para permitir a cópia de camadas",
    "type": "A seleção deve conter somente camadas e grupos",
    "loading": "Aguarde até que o mapa termine de carregar",
    "permissions": "É necessária a permissão “Editar” no plano para copiar camadas e grupos"
  },
  "map_delete_status": {
    "title": "Excluir camadas/grupos",
    "explain": "Exclui as camadas e grupos selecionados",
    "amount": "Selecione pelo menos uma camada ou grupo para ativar a exclusão",
    "type": "A seleção deve conter somente camadas e grupos",
    "loading": "Aguarde até que o mapa termine de carregar",
    "permissions": "Permissão de “administrador” em camadas necessária para excluir camadas e grupos"
  },
  "mapBackgroundError": {
    "title": "Plano de fundo do mapa indisponível",
    "part1": "Não conseguimos carregar o",
    "part2": "plano de fundo, então mudamos para um diferente. Por favor, tente",
    "part3": "novamente mais tarde."
  },
  "qrCode": {
    "copySuccess": "Código QR copiado para a prancheta",
    "copyError": {
      "title": "Falha ao copiar o código QR",
      "message": "Tente novamente ou use a opção de download"
    },
    "downloadSuccess": {
      "title": "Código QR baixado",
      "message": "Verifique sua pasta de downloads"
    },
    "downloadError": {
      "title": "Falha ao baixar o código QR",
      "message": "Por favor, tente novamente"
    }
  },
  "splitLines": {
    "title": "Linha dividida",
    "selectMapObject": "Selecione uma única linha para dividir",
    "lockedLayer": "Não é possível dividir a linha: a camada está bloqueada",
    "linesOnly": "Somente objetos de linha podem ser divididos",
    "fixedShapes": "Não é possível dividir linhas de forma fixa",
    "drawing": "Não é possível dividir a linha ao desenhar",
    "action": "Clique para dividir a linha",
    "confirmMessage": "Tem certeza de que deseja dividir essa linha? Essa ação não pode ser desfeita.",
    "tooltipStart": "Desde o início",
    "tooltipEnd": "Para acabar"
  }
}